export enum InvoiceStatus {
  DRAFT = "DRAFT", // just created
  ISSUED = "ISSUED", // finalized, PDF generated, ready for client
  PARTIALLY_PAID = "PARTIALLY_PAID", // payment received partially
  PAID = "PAID", // payment received
  CANCELLED = "CANCELLED", // voided
}

export enum InvoiceSourceType {
  AMC = "AMC",
  WORK_ORDER = "WORK_ORDER",
  AMC_VISIT = "AMC_VISIT",
  PETTY_WORK = "PETTY_WORK",
}

/**
 * `GET /invoices?sourceType=` tokens (comma-separated). May differ from
 * {@link InvoiceSourceType} on individual records.
 */
export const InvoiceListSourceTypeParam = {
  AMC: "AMC",
  WORK_ORDER: "WORK_ORDER",
  PETTY_WORK: "PETTY_WORK",
} as const;

export type InvoiceListSourceTypeParamValue =
  (typeof InvoiceListSourceTypeParam)[keyof typeof InvoiceListSourceTypeParam];

export const InvoiceListSourceTypeParamLabelMap: Record<
  InvoiceListSourceTypeParamValue,
  string
> = {
  [InvoiceListSourceTypeParam.AMC]: "AMC",
  [InvoiceListSourceTypeParam.WORK_ORDER]: "Work Order",
  [InvoiceListSourceTypeParam.PETTY_WORK]: "Petty Work",
};

export const InvoiceSourceTypeLabelMap: Record<InvoiceSourceType, string> = {
  [InvoiceSourceType.AMC]: "AMC",
  [InvoiceSourceType.WORK_ORDER]: "Work Order",
  [InvoiceSourceType.AMC_VISIT]: "AMC visit",
  [InvoiceSourceType.PETTY_WORK]: "Petty Work",
};

export enum InvoiceItemSourceType {
  AMC = "AMC",
  AMC_VISIT = "AMC_VISIT",
  WORK_ORDER = "WORK_ORDER",
  PRODUCT = "PRODUCT",
  PETTY_WORK = "PETTY_WORK",
}

export const InvoiceStatusMap: Record<
  InvoiceStatus,
  {
    label: string;
    color: "primary" | "info" | "warning" | "success" | "danger" | "secondary";
  }
> = {
  [InvoiceStatus.DRAFT]: {
    label: "Draft",
    color: "secondary", // internal, not final
  },

  [InvoiceStatus.ISSUED]: {
    label: "Issued",
    color: "primary", // officially generated
  },

  [InvoiceStatus.PARTIALLY_PAID]: {
    label: "Partially Paid",
    color: "success", // payment completed
  },

  [InvoiceStatus.PAID]: {
    label: "Paid",
    color: "success", // payment completed
  },

  [InvoiceStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger", // voided
  },
};
